import React, { useEffect } from "react";
import "./SriJagannathRathYatra.css";
import Header from "../../../Components/Header/Header";
import dummy1 from "../SignificanceOfNarasimha/assets/dummy1.jpg";
// import Radhayatra from "./assets/Radhayatra.png";
import Radhayatra from "../assets/0P9A7515.webp";
import Footer from "../../../Components/Footer/Footer";
import RecentBlogs from "../RecentBlogs/RecentBlogs";
import { Helmet } from "react-helmet-async";

const SriJagannathRathYatra = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Sri Jagannath Rath Yatra 2025 – ISKCON Vijayawada | Join the Grand
          Chariot Festival
        </title>
        <meta
          name="description"
          content="Experience the divine Sri Jagannath Rath Yatra in Vijayawada with ISKCON. Join us for a spiritual procession, kirtans, prasadam & cultural celebrations on this auspicious occasion."
        />
        <meta
          name="keywords"
          content="How to join ISKCON Rath Yatra Vijayawada, Spiritual festivals in Vijayawada 2025, ISKCON Vijayawada temple events, Jagannath Rath Yatra cultural programs, Lord Jagannath chariot festival, ISKCON events Vijayawada, Rath Yatra celebrations Andhra Pradesh, Jagannath Puri Rath Yatra ISKCON, Jagannath Rath Yatra Vijayawada, ISKCON Vijayawada Rath Yatra, Rath Yatra 2025"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Sri Jagannath Rath Yatra 2025 – ISKCON Vijayawada | Join the Grand Chariot Festival"
        />
        <meta
          property="og:description"
          content="Experience the divine Sri Jagannath Rath Yatra in Vijayawada with ISKCON. Join us for a spiritual procession, kirtans, prasadam & cultural celebrations on this auspicious occasion."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.iskconvijayawada.org/sri-jagannath-rath-yatra"
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Sri Jagannath Rath Yatra 2025 – ISKCON Vijayawada | Join the Grand Chariot Festival"
        />
        <meta
          name="twitter:description"
          content="Experience the divine Sri Jagannath Rath Yatra in Vijayawada with ISKCON. Join us for a spiritual procession, kirtans, prasadam & cultural celebrations on this auspicious occasion."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/sri-jagannath-rath-yatra"
        />
      </Helmet>
      <Header />
      <div className="  flex justify-center items-center flex-col w-full h-full pb-14">
        <div className="heading-sign flex justify-center items-center  text-2xl md:text-4xl md:font-bold bg-[#c61d21]">
          <h1>Sri Jagannath Rath Yatra Festival in Vijayawada 2025</h1>
        </div>

        <main className="significance-blog">
          <div className="main-section">
            <div className="banner-img">
              <img src={Radhayatra} alt="dummy1" />
            </div>

            <div id="text-content">
              <h2>Vijayawada – A Spiritual and Cultural Hub</h2>
              <p>
                Vijayawada, located on the banks of the Krishna River, is a
                major cultural and commercial hub in Andhra Pradesh. Known for
                the sacred Kanakadurgamma temple and rich Telugu traditions, it
                plays host to one of the largest spiritual events in South
                India—the <b>Sri Jagannath Rath Yatra </b> organized by{" "}
                <a href="http://www.iskconvijayawada.org/">
                  ISKCON Vijayawada.
                </a>
              </p>

              <p>
                <h3 className="mt-4">The Legacy of Jagannath Rath Yatra</h3>
                Inspired by <b>Srila A.C. Bhaktivedanta Swami Prabhupada </b>,
                founder of ISKCON, Rath Yatras are held across the globe.
                Following this legacy, the Rath Yatra in Vijayawada, led by IIT
                graduates and ISKCON devotees from Calcutta, has become the
                largest Rath Yatra in South India. In July 2023, it entered the{" "}
                <b>Indian Book of Records </b>for attracting over 1.25 lakh
                devotees.
              </p>
              <br />

              <p>
                <h3>God’s Pandal – The Magnificent Gundicha Mandir</h3>
                One of the biggest attractions of the Vijayawada Rath Yatra is
                the <b>Gundicha Mandir </b>, also called God’s Pandal.
                Constructed by a skilled team from Calcutta, this 100-foot-high
                structure, with yellow-green drapery and a 40-foot chandelier,
                creates a spectacular sight. Lord Jagannath, along with
                Balabhadra and Subhadra, gives darshan here for three days,
                delighting thousands of devotees.
              </p>
              <br />

              <p>
                <h3>Pre-Events – A Two-Month Spiritual Celebration</h3>
                The festival spirit begins from Akshaya Tritiya, with vibrant
                awareness campaigns and social initiatives:
                <div class="event-highlights">
                  <ul>
                    <li>“HE IS COMING” hoardings along the Rath route.</li>
                    <li>
                      <b>Anti-addiction campaigns</b>, school/college
                      competitions, 3K runs, and themed debates.
                    </li>
                    <li>
                      Social media promotions by vloggers and influencers.
                    </li>
                    <li>
                      <b>“Intintiki Jagannath”</b> campaign by 500+ volunteers.
                    </li>
                    <li>
                      1000+ <b>chappam bhogs</b> prepared by women devotees.
                    </li>
                    <li>
                      Rangavalli decorations and community participation in
                      services.
                    </li>
                  </ul>
                </div>
              </p>

              <br />

              <p>
                <h3>Unity in Diversity – East Meets West</h3>A multicultural
                kirtan team featuring <b>international devotees </b> adds to the
                festival's vibrancy. With{" "}
                <b>Western instruments and Hare Krishna chants </b>, they
                perform on trucks ahead of the chariot, inspiring all with the
                spirit of <b>global harmony through devotion </b>.
              </p>

              <br />

              <p>
                <h3>Jagannath Among the People – A Divine Experience</h3>
                Lord Jagannath’s darshan on the streets of Vijayawada offers an
                extraordinary spiritual experience. Devotees believe that those
                who pull the chariot with faith transcend the cycle of rebirth:
                <br />
                <i>“Radhecha Vamanam Drishthiya Punarjanma Na Vidyate”</i>
                <br />
                Every year, Jagannath, Balabhadra, and Subhadra bless lakhs of
                devotees through this sacred procession.
              </p>

              <br />

              <p>
                <h3 className="mb-2">A Three-Day Grand Rath Mela</h3>
                <ol className="rath-mela-list">
                  <li>
                    <strong>Sand Art Marvels</strong>
                    <br />
                    Giant sculptures of the deities made from sand become the
                    visual highlight of the fair.
                  </li>

                  <li>
                    <strong>Cultural Performances</strong>
                    <br />
                    From Kathak and Kuchipudi to Kerala drums and mythological
                    dramas, cultural programs enrich the Gundicha Mandir
                    atmosphere.
                  </li>

                  <li>
                    <strong>Chariot Parikrama</strong>
                    <br />
                    Thousands take 108 steps around the chariot while chanting
                    Hare Krishna Mahamantras, marking their initiation into a
                    devotional path.
                  </li>

                  <li>
                    <strong>Vibrant Stalls</strong>
                    <br />
                    The temple grounds feature stalls like:
                    <ul>
                      <li>Bhakti Vriksha & Spiritual Book Stalls</li>
                      <li>Kids' Corner</li>
                      <li>Anti-Addiction Signature Campaigns</li>
                      <li>Maha Prasadam Distribution</li>
                    </ul>
                  </li>
                </ol>
              </p>

              <br />

              <p>
                <h3>Grand Celebrations from June 27–29, 2025</h3>
                This year,{" "}
                <a href="http://www.iskconvijayawada.org/">
                  <b>ISKCON Vijayawada </b>
                </a>{" "}
                will host the Rath Yatra from <b>June 27 to 29</b>, under the
                leadership of <b>Sriman Chakradhari Prabhuji</b>, with{" "}
                <b>Honorable CM Shri Nara Chandrababu Naidu </b> as chief guest.
                The chariot procession will start from <b>Sitara Grounds </b>,
                Bhawanipuram, culminating in a three-day <b>Rath Mela </b>.
              </p>

              <br />
              <div class="leaders-speak">
                <h3>Esteemed Leaders Speak</h3>
                <blockquote>
                  <p>
                    <em>
                      “The Vijayawada Rath Yatra is a spiritual blessing to
                      all.”
                    </em>
                    <br />— Sri Biswabhushan Harichandan, Former Governor of
                    Andhra Pradesh
                  </p>

                  <p>
                    <em>
                      “The ISKCON team’s devotion and commitment have made this
                      event truly grand.”
                    </em>
                    <br />— Gokaraju Rangaraju, CMD Laila Group
                  </p>

                  <p>
                    <em>
                      “I promise to build a magnificent Jagannath temple in
                      Vijayawada.”
                    </em>
                    <br />— Kesineni Shivanath (Chinni), MP
                  </p>

                  <p>
                    <em>
                      “The chariot of Jagannath spreads unity and spiritual
                      grace.”
                    </em>
                    <br />— Kolusu Partha Sarathi, Minister of Housing &
                    I&amp;PR
                  </p>
                </blockquote>
              </div>

              <br />
              <p>
                <h3>
                  Jai Jagannath! Celebrate the Festival of Unity, Devotion, and
                  Grace
                </h3>{" "}
                Join the <b>Jagannath Rath Yatra in Vijayawada </b>—a spiritual
                spectacle that merges faith, culture, and celebration. Let the
                divine chariot of <b>Lord Jagannath </b> bring joy, peace, and
                enlightenment to your life.
              </p>
            </div>
          </div>

          <div id="side-bar-section">
            <RecentBlogs />
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default SriJagannathRathYatra;
